/* principal-utilities.js — VibeNest principal runtime helpers (countdown, toast, fade-up,
   FAQ toggle, scroll progress, sticky visibility, review avatars).
   GoKwik buy handler + [data-buy] delegation live in principal.js — do NOT duplicate
   them here (causes the principalBuyClick name collision / double cart.add race we fixed in
   round 7). This file owns ONLY non-conflicting utilities. */
(function() {
  /* -- Bundle radio sync: writes qty, variant-id (if any), and price label to Hero CTA.
        If the picked pack has a linked Shopify product (data-variant-id set in Liquid),
        we add 1 unit of THAT variant — bundle price is baked into the variant.
        If not set (fallback), we add `qty` units of the default product variant. -- */
  var principalHeroCta = document.getElementById('principalHeroCta');
  document.querySelectorAll('[name="principalPack"]').forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (!this.checked) return;
      var qty = parseInt(this.dataset.buyQty || '1', 10);
      var variantId = this.dataset.variantId || '';
      var priceText = this.dataset.now || '&#8377;2,999';
      if (principalHeroCta) {
        principalHeroCta.dataset.buyQty = qty;
        if (variantId) { principalHeroCta.dataset.variantId = variantId; }
        else           { delete principalHeroCta.dataset.variantId; }
        var priceSpan = principalHeroCta.querySelector('.principal-cta-price');
        if (priceSpan) priceSpan.textContent = priceText.replace(/&#8377;/g, '₹');
      }
    });
  });

  window.addEventListener('scroll', function() {
    var el = document.getElementById('principal-progress');
    var s = document.documentElement;
    if (el) el.style.width = ((s.scrollTop || document.body.scrollTop) / (s.scrollHeight - s.clientHeight) * 100) + '%';
  }, { passive: true });

  var hero = document.getElementById('principal-hero-section');
  var sticky = document.getElementById('principal-sticky');
  if (hero && sticky) {
    window.addEventListener('scroll', function() {
      sticky.classList.toggle('principal-visible', hero.getBoundingClientRect().bottom < 0);
    }, { passive: true });
  }

  if (window.IntersectionObserver) {
    var fuObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('principal-vis'); fuObs.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    setTimeout(function() {
      document.querySelectorAll('.principal-fu').forEach(function(el) { fuObs.observe(el); });
    }, 300);
  } else {
    document.querySelectorAll('.principal-fu').forEach(function(el) { el.classList.add('principal-vis'); });
  }

  window.principalFaqToggle = function(btn) {
    var item = btn.parentElement;
    var wasOpen = item.classList.contains('principal-open');
    document.querySelectorAll('.principal-faq-item.principal-open').forEach(function(c) { c.classList.remove('principal-open'); });
    if (!wasOpen) item.classList.add('principal-open');
  };

  setTimeout(function() {
    ['principal-hc1','principal-hc2','principal-hc3'].forEach(function(id, i) {
      var el = document.getElementById(id);
      if (!el) return;
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) { setTimeout(function() { el.classList.add('principal-how-card-active'); el.style.opacity=1; el.style.transform='scale(1.02)'; }, i * 180); }
      }, { threshold: 0.15 }).observe(el);
    });
  }, 400);

  /* -- Urgency countdown -- */
  var principalEndT = Date.now() + (7200 + Math.floor(Math.random() * 5400)) * 1000;
  function principalTick() {
    var diff = principalEndT - Date.now();
    if (diff < 0) { principalEndT = Date.now() + 10800000; diff = 10800000; }
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var el = document.getElementById('principal-countdown');
    if (el) el.textContent = (h<10?'0':'')+h+':'+(m<10?'0':'')+m+':'+(s<10?'0':'')+s;
  }
  principalTick(); setInterval(principalTick, 1000);

  /* -- Live viewers -- */
  var principalVC = 8 + Math.floor(Math.random() * 16);
  var principalVEl = document.getElementById('principal-viewers');
  if (principalVEl) principalVEl.textContent = principalVC + ' people';
  setInterval(function() {
    principalVC = Math.max(6, Math.min(29, principalVC + (Math.random() > 0.5 ? 1 : -1)));
    if (principalVEl) principalVEl.textContent = principalVC + ' people';
  }, 7500);

  /* -- Social proof toast -- */
  var principalTD = [
    { init:'RS', name:'Rahul S.', city:'Delhi', qty:'1 ChillNest', time:'2 min ago', color:'#00BE63' },
    { init:'PM', name:'Priya M.', city:'Mumbai', qty:'2 ChillNests', time:'5 min ago', color:'#7C3AED' },
    { init:'AK', name:'Ankit K.', city:'Bangalore', qty:'1 ChillNest', time:'8 min ago', color:'#00BE63' },
    { init:'SK', name:'Sneha K.', city:'Chennai', qty:'1 ChillNest', time:'12 min ago', color:'#16A34A' },
    { init:'VT', name:'Vikram T.', city:'Hyderabad', qty:'3 ChillNests', time:'15 min ago', color:'#D97706' },
    { init:'ND', name:'Neha D.', city:'Pune', qty:'1 ChillNest', time:'18 min ago', color:'#DC2626' },
    { init:'KR', name:'Karan R.', city:'Ahmedabad', qty:'2 ChillNests', time:'21 min ago', color:'#059669' }
  ];
  var principalTI = 0;
  function principalToastShow() {
    var t = principalTD[principalTI % principalTD.length];
    var card = document.getElementById('principal-toast-card');
    if (!card) return;
    document.getElementById('principal-tav').textContent = t.init;
    document.getElementById('principal-tav').style.background = t.color;
    document.getElementById('principal-tname').textContent = t.name;
    document.getElementById('principal-taction').textContent = 'ordered ' + t.qty + ' from ' + t.city;
    document.getElementById('principal-ttime').textContent = t.time;
    card.classList.add('principal-tshow');
    setTimeout(function() { card.classList.remove('principal-tshow'); }, 3800);
    principalTI++;
  }
  setTimeout(principalToastShow, 3500);
  setInterval(principalToastShow, 9000);

  /* -- Review avatar injection -- */
  setTimeout(function() {
    var avC = ['#00BE63','#7C3AED','#00BE63','#16A34A','#D97706','#DC2626','#059669','#6D28D9'];
    var dates = ['3 days ago','5 days ago','1 week ago','10 days ago','2 weeks ago','3 weeks ago','1 month ago','6 weeks ago','2 months ago','3 months ago'];
    var plat = ['Amazon Verified','VibeNest Order','Amazon Verified','VibeNest Order','Amazon Verified','VibeNest Order','Amazon Verified'];
    var ri = 0;
    document.querySelectorAll('.principal-rev-card').forEach(function(card) {
      if (card.querySelector('.principal-rev-top')) return;
      var aEl = card.querySelector('.principal-rev-author');
      if (!aEl) return;
      var fullName = aEl.textContent.trim();
      var parts = fullName.replace('.','').split(' ');
      var init = ((parts[0]||'?')[0] + ((parts[1]||'')[0]||'')).toUpperCase();
      var color = avC[ri % avC.length];
      var cEl = card.querySelector('.principal-rev-city');
      var cityTxt = cEl ? ' &middot; ' + cEl.textContent : '';
      var tagEl = card.querySelector('.principal-rev-tag');
      var topH = '<div class="principal-rev-top"><div class="principal-rev-av" style="background:' + color + '">' + init + '</div><div class="principal-rev-av-meta"><span class="principal-rev-av-name">' + fullName + cityTxt + '</span><span class="principal-rev-vbadge">&#10003; ' + plat[ri % plat.length] + '</span><span class="principal-rev-dt">' + dates[ri % dates.length] + '</span></div></div>';
      var helpH = '<div class="principal-rev-helpful"><span>Helpful?</span><button class="principal-rev-hbtn" onclick="this.textContent=\'&#128077; Yes (1)\'">&#128077; Yes</button></div>';
      card.insertAdjacentHTML('afterbegin', topH);
      card.insertAdjacentHTML('beforeend', helpH);
      aEl.remove();
      if (cEl) cEl.remove();
      if (tagEl) tagEl.remove();
      ri++;
    });
  }, 700);

})();
